import { Component, Input, ViewEncapsulation } from '@angular/core';
import { PortalActionRow } from './models/reports';

@Component({
  moduleId: module.id.toString(),
  selector: 'report-portal-actions-panel-v3',
  templateUrl: './templates/report-portal-actions-panel-v3.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class ReportPortalActionsPanelV3Component {
  @Input() rows: PortalActionRow[] = [];
  @Input() loading: boolean = false;

  expanded: boolean = true;
  private expandedActionTypes: Set<string> = new Set();

  isExpanded(actionType: string): boolean {
    return this.expandedActionTypes.has(actionType);
  }

  toggleBreakdown(row: PortalActionRow) {
    if (row.breakdown && row.breakdown.length) {
      if (this.expandedActionTypes.has(row.action_type)) {
        this.expandedActionTypes.delete(row.action_type);
      } else {
        this.expandedActionTypes.add(row.action_type);
      }
    }
  }
}
